/* ============================================================================
   RK SCHNELLKAUF — Plus-Knopf auf Produktkacheln

   Ein Tipp legt den Artikel in den Warenkorb und öffnet die eigene
   Schublade mit dem neuen Inhalt. Hört am Dokument mit, damit auch
   nachgeladene Kacheln („Mehr laden“) funktionieren.
   Powered by René Kress - Crovio · www.crovio.de
   ========================================================================= */
(function () {
  'use strict';
  if (window.rkSchnellkaufBereit) return;
  window.rkSchnellkaufBereit = true;

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-rk-schnell]');
    if (!knopf || knopf.disabled) return;
    e.preventDefault();
    var schublade = document.querySelector('cart-drawer');
    knopf.disabled = true;
    knopf.classList.add('is-laedt');

    var daten = new FormData();
    daten.append('id', knopf.getAttribute('data-rk-schnell'));
    daten.append('quantity', '1');
    if (schublade) {
      daten.append('sections', 'cart-drawer,cart-icon-bubble');
      daten.append('sections_url', window.location.pathname);
    }

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: daten
    })
      .then(function (a) { return a.json().then(function (j) { return { ok: a.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok || r.j.status) throw new Error(r.j.description || 'Fehler');
        knopf.classList.remove('is-laedt');
        knopf.classList.add('is-drin');
        var zeichen = knopf.querySelector('.rk-pkarte__plus-zeichen');
        if (zeichen) zeichen.textContent = '✓';
        setTimeout(function () {
          knopf.classList.remove('is-drin');
          if (zeichen) zeichen.textContent = '+';
          knopf.disabled = false;
        }, 2200);
        if (schublade && r.j.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(r.j);
        } else if (!schublade) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('rk:warenkorb-geaendert'));
      })
      .catch(function () {
        knopf.classList.remove('is-laedt');
        knopf.disabled = false;
      });
  });
})();
